import styled from "styled-components";

export default styled.div`
  /* display: flex;
  position: relative;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%; */

  .left-section {
    .text-container {
      width: 100%;

      .MuiTypography-root {
        display: block;
        text-wrap: nowrap;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        text-overflow: ellipsis;
      }
    }
  }

  .right-section {
    position: absolute;
    top: 5px;
    right: 5px;
    transform: translate(0%, 0%);
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .MuiTypography-root {
      height: fit-content;
      display: block;
    }
  }
`;
